import React from "react";
import { Row, Col } from "react-bootstrap";
import RespIm from "./RespIm";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/botones.css";
export default function Home(props) {
  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <a href="https://www.entrenamientopostural.com/">
          <RespIm
            x0={1003}
            y0={700}
            x={600}
            src={require("../images/Logo.png").default}
          />
        </a>
      </div>

      <Row fluid className="justify-content-center">
        <Col
          className="text-center"
          xs={12}
          xl={2}
          style={{ paddingTop: "25px" }}
        >
          <button class="botones2" onClick={() => props.setEstado({ n: 1 })}>
            {" "}
            Ingresar{" "}
          </button>
        </Col>
        <Col
          className="text-center"
          xs={12}
          xl={2}
          style={{ paddingTop: "25px" }}
        >
          <button class="botones2" onClick={() => props.setEstado({ n: 2 })}>
            {" "}
            Registrarse{" "}
          </button>
        </Col>
      </Row>
    </div>
  );
}
